import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { environment } from 'mapfre-auditmap/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap } from "rxjs/operators";
import { FileService, CacheService, IActivityBO, ITypeConceptImputationBO } from '@mapfre-tech/amap3';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  className = 'ActivityService';

  constructor(private http: HttpClient, private fileService: FileService, private cacheService: CacheService) {
  }

  /*
  * Activities Type
  */

  getAllActivitiesTypes(cache = true, cacheKey = "allActivitiesTypes"): Observable<ITypeConceptImputationBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeConceptImputationBO[]>;
    } else {
      const observable = this.http.get<ITypeConceptImputationBO[]>(environment.base_URL + "/activity-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newActivity(activity: ITypeConceptImputationBO): Observable<ITypeConceptImputationBO> {
    return this.http.post<ITypeConceptImputationBO>(environment.base_URL + "/activity-types", activity)
  }

  newActivityPai(activity: IActivityBO): Observable<IActivityBO[]> {
    return this.http.post<IActivityBO[]>(environment.base_URL + "/activities", activity)
  }

  addActivityWithFiles(activity: IActivityBO): Observable<number> {
    // PRE FILES INI
    const fileNames: any[] = activity.fileNames ?? [];
    const filesToUpload = fileNames.filter((f: any) => f instanceof File);
    activity.fileNames = fileNames.filter((f: any) => !(f instanceof File));
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (filesToUpload.length > 0) {
      return this.newActivityPai(activity).pipe(mergeMap((res: IActivityBO[]) => {
        const activityId = res[0]?.idActivityPk?.toString() ?? '';
        const observables: Observable<unknown>[] = filesToUpload.map((f) => this.fileService.upload(f, 'activity', activityId));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res[0]?.idActivityPk ?? 0;
        }));
      }))
    }
    else {
      return this.newActivityPai(activity).pipe(map((res: IActivityBO[]) => res[0]?.idActivityPk ?? 0))
    }
  }

  addActivityListWithFiles(activities: IActivityBO[]): Observable<number[]> {
    const observables = activities.map((activity: IActivityBO) => this.addActivityWithFiles(activity));
    return forkJoin(observables);
  }

  updateActivityPai(activity: IActivityBO, id: number) {
    return this.http.put(environment.base_URL + `/activities/${id}`, activity)
  }

  deleteActivityPai(id: number) {
    return this.http.delete(environment.base_URL + `/activities/${id}`)
  }

  updateActivity(activity: ITypeConceptImputationBO, id: number) {
    return this.http.put(environment.base_URL + `/activity-types/${id}`, activity)
  }


  getAllActivitiesByPai(id: number): Observable<IActivityBO[]> {
    const params: any = {};
    params.paiId = id;
    return this.http.get<IActivityBO[]>(environment.base_URL + "/activities", { params })
  }


  getAllActivities(): Observable<IActivityBO[]> {
    return this.http.get<IActivityBO[]>(environment.base_URL + "/activities")
  }

  getActivity(id: number): Observable<IActivityBO[]> {
    const params = {
      idActivityPk: id
    }
    return this.http.get<IActivityBO[]>(environment.base_URL + "/activities", { params });
  }

}
